module.exports = __webpack_public_path__ + "img/左右翻转-角标.dd62bc81.svg";